import { useSearchParams } from 'react-router';
import { useFlags } from 'src/feature-flags/FlagsHook';

export function useFamilyReviewId(): string | undefined {
  const [searchParams] = useSearchParams();
  const { flagEnabledFamilyDocumentsRevamp } = useFlags();
  if (!flagEnabledFamilyDocumentsRevamp) return undefined;
  return searchParams.get('familyId') ?? undefined;
}
